module.exports = __webpack_public_path__ + "static/media/empty.4ad73b74.png";